import { render, staticRenderFns } from "./loaderRegister.vue?vue&type=template&id=22ebf954&scoped=true&"
var script = {}
import style0 from "./loaderRegister.vue?vue&type=style&index=0&id=22ebf954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ebf954",
  null
  
)

export default component.exports